import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import Router from "./routers";
import initI18n from "locales/i18n";

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement,
);

initI18n();

root.render(
    // <React.StrictMode>
    <Router />,
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
